const state = {
  usableList: [],
  prevFetchTime: 0,
}

const getters = {
}

const mutations = {
  setUsableList (state, value) {
    state.usableList = value
    state.prevFetchTime = Date.now()
  },
}

const actions = {
  activate ({ state, commit, rootState }, params) {
    return rootState.axios.post('/coupon/v1frontend/couponrel/activate', params)
  },
  merge ({ state, commit, rootState }, params) {
    return rootState.axios.post('/coupon/v1frontend/couponrel/merge', params)
  },
  updateUpdatedTime ({ state, commit, rootState }, params) {
    return rootState.axios.post('/coupon/v1frontend/couponrel/update-updated-time', params)
  },
  index ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coupon/v1frontend/couponrel/index', { params }).then(res => {
      res.data.list.forEach(item => {
        let unable = false
        const now = Date.now()
        // 超过使用次数
        if (item.cpnUsageMax !== '-1' && item.crUsage >= item.cpnUsageMax) {
          unable = 'usage'
        }
        // 已啟用并且已过期
        if (item.expiredTime !== '0' && item.expiredTime * 1000 < now) {
          unable = 'expired'
        }
        // if (item.activeTime > 0 && item.activeTime * 1000 < now) {
        //   unable = false
        // }
        if (item.activeTime > 0 && item.activeTime * 1000 > now) {
          unable = 'unavailable' // 未到可用时间
        }
        item.unable = unable
      })
      return res
    })
  },
  fetchUsableList ({ state, commit, dispatch, rootState }, params) {
    return dispatch('index', {
      isUsable: 'Y',
      isActivate: 'Y',
      cpnBiz: 'JY',
      page: 1,
      pageSize: 1000,
    }).then(res => {
      return dispatch('index', {
        isUsable: 'Y',
        isGroupCpnCode: 'Y',
        cpnBiz: 'JY',
        page: 1,
        pageSize: 1000,
      }).then(res2 => {
        commit('setUsableList', res.data.list.concat(res2.data.list))
      })
    })
  },
  receiveTb19 ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coupon/v1frontend/couponrel/receive-tb19', params)
  },
  searchMission ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coupon/v1frontend/couponrel/search-mission', params)
  },
  receiveXm ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coupon/v1frontend/couponrel/receive-xm', params)
  },
  searchMgref ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coupon/v1frontend/couponrel/search-mgref', { params })
  },
  receiveLong91 ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coupon/v1frontend/couponrel/receive-long91', { params })
  },
  searchLong91 ({ state, commit, rootState }, params) {
    return rootState.axios.get('/coupon/v1frontend/couponrel/search-long91', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
